import { getRatingColor } from 'new-beginning/components/pages/EmployerProfile/helpers';
import { useMemo } from 'react';

export const useBenefitsRatingColor = (rating: string | number) => {
	const benefitsRatingColor = useMemo(() => getRatingColor(Number(rating)), [rating]);

	return benefitsRatingColor;
};
